// Branding Module
export const getBranding = () => ({
  type: 'GET_BRANDING'
})

// Profile Module - Accounts
export const getMe = () => ({
  type: 'GET_ME'
})

export const setUserDetails = (data) => ({
  payload: data,
  type: 'SET_USER_DETAILS'
})

export const refreshSubscription = () => ({
  type: 'REFRESH_SUBSCRIPTION'
})

export const updateProfile = (payload) => ({
  payload,
  type: 'UPDATE_PROFILE'
})

export const changePassword = (payload) => ({
  payload,
  type: 'CHANGE_PASSWORD'
})

export const setCtrlPressed = (payload) => ({
  payload,
  type: 'SET_CTRL_PRESSED'
})

// Workspace Module - Accounts

export const switchWorkspace = (payload) => ({ 
  payload,
  type: 'SWITCH_WORKSPACE'
})

export const createWorkspace = (payload) => ({ 
  payload,
  type: 'CREATE_WORKSPACE'
})

export const setNewWorkspaceModal = (payload) => ({ 
  payload,
  type: 'SET_NEW_WORKSPACE_MODAL'
})

export const updateWorkspace = (payload) => ({ 
  payload,
  type: 'UPDATE_WORKSPACE'
})

export const setUpdateWorkspace = (payload) => ({ 
  payload,
  type: 'SET_UPDATE_WORKSPACE'
})

export const getPendingInvites = (payload) => ({
  payload,
  type: 'GET_PENDING_INVITES'
})

export const resendInvite = (payload) => ({
  payload,
  type: 'RESEND_INVITE'
})

export const acceptInvite = (payload) => ({
  payload,
  type: 'ACCEPT_INVITE'
})

export const setPendingInvites = (payload) => ({
  payload,
  type: 'SET_PENDING_INVITES'
})

export const createMember = (payload) => ({ 
  payload,
  type: 'CREATE_MEMBER'
})

export const updateMember = (payload) => ({ 
  payload,
  type: 'UPDATE_MEMBER'
})

export const deleteMember = (payload) => ({ 
  payload,
  type: 'DELETE_MEMBER'
})

// API Key Module - Settings
export const getApiKeys = () => ({
  type: 'GET_API_KEYS'
})

export const createApiKey = (payload) => ({
  payload,
  type: 'CREATE_API_KEY'
})

export const deleteApiKey = (payload) => ({
  payload,
  type: 'DELETE_API_KEY'
})

export const setApiKeys = (payload) => ({
  payload,
  type: 'SET_API_KEYS'
})

export const setApiKeyCreated = (payload) => ({
  payload,
  type: 'SET_API_KEY_CREATED'
})

// Phone Verification Module
export const sendPhoneVerification = (payload) => ({
  payload,
  type: 'SEND_PHONE_VERIFICATION'
})

export const verifyPhoneCode = (payload) => ({
  payload,
  type: 'VERIFY_PHONE_CODE'
})